<template>
  <DxPieChart
    id="pie"
    :data-source="areas"
    palette="Bright"
    :title="$t('DxOptimalCropDistributionPieChart_title')"
    @point-click="pointClickHandler($event)"
    @legend-click="legendClickHandler($event)"
  >
    <DxSeries
      argument-field="crop"
      value-field="area"
    >
      <DxLabel
        :visible="true"
        format="percent"
        width="100"
      />
    </DxSeries>

    <DxExport :enabled="true" />
  </DxPieChart>
</template>

<script>

import DxPieChart, {
  DxSeries,
  DxLabel,
  DxConnector,
  DxExport,
} from 'devextreme-vue/pie-chart';

export default {
  name: 'DxOptimalCropDistributionPieChart',
  components: {
    DxPieChart,
    DxSeries,
    DxLabel,
    DxConnector,
    DxExport,
  },
  props: {
    areas: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    pointClickHandler(e) {
      this.toggleVisibility(e.target);
    },
    legendClickHandler(e) {
      const arg = e.target;
      const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];
      this.toggleVisibility(item);
    },
    toggleVisibility(item) {
      // eslint-disable-next-line no-unused-expressions
      item.isVisible() ? item.hide() : item.show();
    },
  },
};
</script>

<style>
#pie {
    height: 440px;
}

#pie * {
    margin: 0 auto;
}
</style>
